import { Injectable } from '@angular/core'
import { AngularFireFunctions } from '@angular/fire/compat/functions'

@Injectable({
  providedIn: 'root',
})
export class EmailService {
  constructor(private cloudFunctions: AngularFireFunctions) {}

  send(sender: string, email: string, subject: string, html: string) {
    const sendEmail = this.cloudFunctions.httpsCallable('sendEmail')
    sendEmail({ sender, email, subject, html }).subscribe({
      error: error => {
        const reason = error?.details?.reason ?? error?.code ?? 'unknown'
        console.error(`sendEmail refused (${reason}): ${subject}`)
      },
    })
  }
}
